import React, { Component } from 'react';
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  Radio,
  Checkbox,
} from 'react-bootstrap';
import _ from 'lodash';
import FontAwesome from 'react-fontawesome';
import getContent from './Contents/Payments';
import Select from '../Select';

export default class Payments extends Component {
  options = () => ({
    // OptionA
    paidType: this.props.paidType,
    feeType: this.props.feeType,
    scheduleType: this.props.scheduleType,
    paySchedule: this.props.paySchedule,
    amount: this.props.amount || '',
    day: this.props.day || '',
    amount1: this.props.amount1 || '',
    amount2: this.props.amount2 || '',
    // OptionsB
    percentage: this.props.percentage || '',
    sales: this.props.sales,
    performances: this.props.performances,
    licenses: this.props.licenses,
    any: this.props.any,
    period: this.props.period,
    periodDay: this.props.periodDay,
    // OptionC
    auditType: this.props.auditType,
    statutoryPercentage: this.props.statutoryPercentage || '',
    ownershipBlock: _.find(
      this.props.filterBlocks,
      (block) => block.name === 'Ownership'
    ),
    dealType: 'create',
  });

  handleContent(field, value) {
    if (
      (field === 'percentage' || field === 'statutoryPercentage') &&
      value > 100
    ) {
      return;
    }
    const options = this.options();
    options[field] = value;

    if ((field === 'amount1' || field === 'amount2') && value !== '') {
      options['paySchedule'] = 1;
      options['day'] = '';
      options['scheduleType'] = '';
    }

    if ((field === 'day' || field === 'scheduleType') && value !== '') {
      options['paySchedule'] = 0;
      options['amount1'] = '';
      options['amount2'] = '';
    }

    if (field === 'paySchedule') {
      if (value === 0) {
        options['amount1'] = '';
        options['amount2'] = '';
      } else if (value === 1) {
        options['day'] = '';
        options['scheduleType'] = '';
      }
    }

    this.props.updateBlock(this.props.block.id, getContent(options), options);
  }

  render() {
    const ownershipBlock = _.find(
      this.props.filterBlocks,
      (block) => block.name === 'Ownership'
    );

    return (
      <div className="tab-content payment-tab">
        <Row>
          <Col sm={12}>
            <div className="questions">
              <p className="question">How will the Producer Be Paid?</p>
              <FormGroup className="answer">
                <Radio
                  name="paidType"
                  checked={this.props.paidType === 0}
                  readOnly
                  onClick={(e) => this.handleContent('paidType', 0)}
                >
                  The Producer will be paid a fee and will not receive a
                  royalty.
                </Radio>
                {this.props.paidType === 0 && (
                  <ul className="sub-answer">
                    <li>
                      <FormGroup>
                        The Producer will be paid a rate of $&nbsp;
                        <FormControl
                          type="number"
                          className="input-sm"
                          placeholder="$"
                          value={this.props.amount ? this.props.amount : ''}
                          onChange={(e) =>
                            this.handleContent('amount', e.target.value)
                          }
                        />
                        &nbsp;&nbsp;
                        <Select
                          className="select-mini"
                          value={this.props.feeType}
                          onChange={(e) =>
                            this.handleContent('feeType', e.target.value)
                          }
                        >
                          <option value="">select</option>
                          <option value="perHour">per hour</option>
                          <option value="flatFee">in total</option>
                        </Select>
                      </FormGroup>
                      <div className="indent-style">
                        <FormGroup>
                          <Radio
                            name="paySchedule"
                            checked={this.props.paySchedule === 0}
                            readOnly
                            onClick={(e) =>
                              this.handleContent('paySchedule', 0)
                            }
                          >
                            The Producer will be paid &nbsp;
                            <FormControl
                              type="number"
                              className="input-sm"
                              placeholder="#"
                              value={this.props.day ? this.props.day : ''}
                              onChange={(e) =>
                                this.handleContent('day', e.target.value)
                              }
                            />
                            &nbsp; days &nbsp;
                            <Select
                              className="select-mini"
                              value={this.props.scheduleType}
                              onChange={(e) =>
                                this.handleContent(
                                  'scheduleType',
                                  e.target.value
                                )
                              }
                            >
                              <option value="">select</option>
                              <option value="execution">
                                following the full execution of this agreement
                              </option>
                              <option value="completion">
                                following the completion and delivery of the
                                services
                              </option>
                            </Select>
                          </Radio>
                          <Radio
                            name="paySchedule"
                            checked={this.props.paySchedule === 1}
                            readOnly
                            onClick={(e) =>
                              this.handleContent('paySchedule', 1)
                            }
                          >
                            The Producer will be paid $&nbsp;
                            <FormControl
                              type="number"
                              className="input-sm"
                              placeholder="$"
                              value={
                                this.props.amount1 ? this.props.amount1 : ''
                              }
                              onChange={(e) =>
                                this.handleContent('amount1', e.target.value)
                              }
                            />{' '}
                            &nbsp;following full execution of this agreement and
                            the balance $&nbsp;
                            <FormControl
                              type="number"
                              className="input-sm"
                              placeholder="$"
                              value={
                                this.props.amount2 ? this.props.amount2 : ''
                              }
                              onChange={(e) =>
                                this.handleContent('amount2', e.target.value)
                              }
                            />{' '}
                            &nbsp;following the completion and delivery of the
                            services&nbsp;
                          </Radio>
                        </FormGroup>
                      </div>
                    </li>
                  </ul>
                )}

                <Radio
                  name="paidType"
                  checked={this.props.paidType === 1}
                  readOnly
                  onClick={(e) => this.handleContent('paidType', 1)}
                >
                  The Producer will be paid a fee and will receive a royalty of
                  net receipts.
                </Radio>
                {this.props.paidType === 1 && (
                  <ul className="sub-answer">
                    <li>
                      <FormGroup>
                        The Producer will be paid a rate of $&nbsp;
                        <FormControl
                          type="number"
                          className="input-sm"
                          placeholder="$"
                          value={this.props.amount ? this.props.amount : ''}
                          onChange={(e) =>
                            this.handleContent('amount', e.target.value)
                          }
                        />
                        &nbsp;&nbsp;
                        <Select
                          className="select-mini"
                          value={this.props.feeType}
                          onChange={(e) =>
                            this.handleContent('feeType', e.target.value)
                          }
                        >
                          <option value="">select</option>
                          <option value="perHour">per hour</option>
                          <option value="flatFee">in total</option>
                        </Select>
                      </FormGroup>
                      <div className="indent-style">
                        <FormGroup>
                          <Radio
                            name="paySchedule"
                            checked={this.props.paySchedule === 0}
                            readOnly
                            onClick={(e) =>
                              this.handleContent('paySchedule', 0)
                            }
                          >
                            The Producer will be paid &nbsp;
                            <FormControl
                              type="number"
                              className="input-sm"
                              placeholder="#"
                              value={this.props.day ? this.props.day : ''}
                              onChange={(e) =>
                                this.handleContent('day', e.target.value)
                              }
                            />
                            &nbsp; days &nbsp;
                            <Select
                              className="select-mini"
                              value={this.props.scheduleType}
                              onChange={(e) =>
                                this.handleContent(
                                  'scheduleType',
                                  e.target.value
                                )
                              }
                            >
                              <option value="">select</option>
                              <option value="execution">
                                following the full execution of this agreement
                              </option>
                              <option value="completion">
                                following the completion and delivery of the
                                services
                              </option>
                            </Select>
                          </Radio>
                        </FormGroup>
                        <FormGroup>
                          <Radio
                            name="paySchedule"
                            checked={this.props.paySchedule === 1}
                            readOnly
                            onClick={(e) =>
                              this.handleContent('paySchedule', 1)
                            }
                          >
                            The Producer will be paid $&nbsp;
                            <FormControl
                              type="number"
                              className="input-sm"
                              placeholder="$"
                              value={
                                this.props.amount1 ? this.props.amount1 : ''
                              }
                              onChange={(e) =>
                                this.handleContent('amount1', e.target.value)
                              }
                            />{' '}
                            &nbsp;following full execution of this agreement and
                            the balance $&nbsp;
                            <FormControl
                              type="number"
                              className="input-sm"
                              placeholder="$"
                              value={
                                this.props.amount2 ? this.props.amount2 : ''
                              }
                              onChange={(e) =>
                                this.handleContent('amount2', e.target.value)
                              }
                            />{' '}
                            &nbsp;following the completion and delivery of the
                            services&nbsp;
                          </Radio>
                        </FormGroup>
                      </div>
                    </li>
                    <li>
                      <FormGroup>
                        The Producer will be paid a royalty of &nbsp;
                        <FormControl
                          type="number"
                          className="input-sm"
                          placeholder="%"
                          value={
                            this.props.percentage ? this.props.percentage : ''
                          }
                          onChange={(e) =>
                            this.handleContent('percentage', e.target.value)
                          }
                        />{' '}
                        &nbsp;% of Owner’s Net Receipts from all (check any):
                        <div className="indent-style">
                          <Checkbox
                            name="sales"
                            checked={this.props.sales === true}
                            onChange={(e) =>
                              this.handleContent('sales', e.target.checked)
                            }
                          >
                            Sales
                          </Checkbox>
                          <Checkbox
                            name="performances"
                            checked={this.props.performances === true}
                            onChange={(e) =>
                              this.handleContent(
                                'performances',
                                e.target.checked
                              )
                            }
                          >
                            Performances
                          </Checkbox>
                          <Checkbox
                            name="licenses"
                            checked={this.props.licenses === true}
                            onChange={(e) =>
                              this.handleContent('licenses', e.target.checked)
                            }
                          >
                            Licenses
                          </Checkbox>
                          <Checkbox
                            name="any"
                            checked={this.props.any === true}
                            onChange={(e) =>
                              this.handleContent('any', e.target.checked)
                            }
                          >
                            Any other exploitations of the Master(s)
                          </Checkbox>
                        </div>
                        <div className="indent-style">
                          <FormGroup>
                            Royalties will be paid and accounted to the Producer
                            over a &nbsp;
                            <Select
                              className="select-mini"
                              value={this.props.period}
                              onChange={(e) =>
                                this.handleContent('period', e.target.value)
                              }
                            >
                              <option value="">select</option>
                              <option value="monthly">monthly</option>
                              <option value="quarterly">quarterly</option>
                              <option value="annual">annual</option>
                            </Select>{' '}
                            &nbsp;period within&nbsp;
                            <Select
                              className="select-mini"
                              value={this.props.periodDay}
                              onChange={(e) =>
                                this.handleContent('periodDay', e.target.value)
                              }
                            >
                              <option value="">select</option>
                              <option value="30">30</option>
                              <option value="60">60</option>
                              <option value="90">90</option>
                            </Select>
                            &nbsp;days of the end of that period.
                          </FormGroup>
                        </div>
                      </FormGroup>
                    </li>
                    <li>
                      <FormGroup>
                        The Producer &nbsp;
                        <Select
                          className="select-mini"
                          value={this.props.auditType}
                          onChange={(e) =>
                            this.handleContent('auditType', e.target.value)
                          }
                        >
                          <option value="">select</option>
                          <option value="will">will</option>
                          <option value="notWill">will not</option>
                        </Select>{' '}
                        &nbsp;have the right to conduct an audit
                      </FormGroup>
                    </li>
                  </ul>
                )}

                <Radio
                  name="paidType"
                  checked={this.props.paidType === 2}
                  readOnly
                  onClick={(e) => this.handleContent('paidType', 2)}
                >
                  The Producer will be paid an advance of their royalty from net
                  receipts.
                </Radio>
                {this.props.paidType === 2 && (
                  <ul className="sub-answer">
                    <li>
                      <FormGroup>
                        The advance will be of $&nbsp;
                        <FormControl
                          type="number"
                          className="input-sm"
                          placeholder="$"
                          value={this.props.amount ? this.props.amount : ''}
                          onChange={(e) =>
                            this.handleContent('amount', e.target.value)
                          }
                        />
                      </FormGroup>
                      <div className="indent-style">
                        <FormGroup>
                          <Radio
                            name="paySchedule"
                            checked={this.props.paySchedule === 0}
                            readOnly
                            onClick={(e) =>
                              this.handleContent('paySchedule', 0)
                            }
                          >
                            The Producer will be paid &nbsp;
                            <FormControl
                              type="number"
                              className="input-sm"
                              placeholder="#"
                              value={this.props.day ? this.props.day : ''}
                              onChange={(e) =>
                                this.handleContent('day', e.target.value)
                              }
                            />
                            &nbsp; days &nbsp;
                            <Select
                              className="select-mini"
                              value={this.props.scheduleType}
                              onChange={(e) =>
                                this.handleContent(
                                  'scheduleType',
                                  e.target.value
                                )
                              }
                            >
                              <option value="">select</option>
                              <option value="execution">
                                following the full execution of this agreement
                              </option>
                              <option value="completion">
                                following the completion and delivery of the
                                services
                              </option>
                            </Select>
                          </Radio>
                        </FormGroup>
                        <FormGroup>
                          <Radio
                            name="paySchedule"
                            checked={this.props.paySchedule === 1}
                            readOnly
                            onClick={(e) =>
                              this.handleContent('paySchedule', 1)
                            }
                          >
                            The Producer will be paid $&nbsp;
                            <FormControl
                              type="number"
                              className="input-sm"
                              placeholder="$"
                              value={
                                this.props.amount1 ? this.props.amount1 : ''
                              }
                              onChange={(e) =>
                                this.handleContent('amount1', e.target.value)
                              }
                            />{' '}
                            &nbsp;following full execution of this agreement and
                            the balance $&nbsp;
                            <FormControl
                              type="number"
                              className="input-sm"
                              placeholder="$"
                              value={
                                this.props.amount2 ? this.props.amount2 : ''
                              }
                              onChange={(e) =>
                                this.handleContent('amount2', e.target.value)
                              }
                            />{' '}
                            &nbsp;following the completion and delivery of the
                            services&nbsp;
                          </Radio>
                        </FormGroup>
                      </div>
                    </li>
                    <li>
                      <FormGroup>
                        The Producer will be paid a royalty of &nbsp;
                        <FormControl
                          type="number"
                          className="input-sm"
                          placeholder="%"
                          value={
                            this.props.percentage ? this.props.percentage : ''
                          }
                          onChange={(e) =>
                            this.handleContent('percentage', e.target.value)
                          }
                        />{' '}
                        &nbsp;% of Owner’s Net Receipts from all (check any):
                        <div className="indent-style">
                          <Checkbox
                            name="sales"
                            checked={this.props.sales === true}
                            onChange={(e) =>
                              this.handleContent('sales', e.target.checked)
                            }
                          >
                            Sales
                          </Checkbox>
                          <Checkbox
                            name="performances"
                            checked={this.props.performances === true}
                            onChange={(e) =>
                              this.handleContent(
                                'performances',
                                e.target.checked
                              )
                            }
                          >
                            Performances
                          </Checkbox>
                          <Checkbox
                            name="licenses"
                            checked={this.props.licenses === true}
                            onChange={(e) =>
                              this.handleContent('licenses', e.target.checked)
                            }
                          >
                            Licenses
                          </Checkbox>
                          <Checkbox
                            name="any"
                            checked={this.props.any === true}
                            onChange={(e) =>
                              this.handleContent('any', e.target.checked)
                            }
                          >
                            Any other exploitations of the Master(s)
                          </Checkbox>
                        </div>
                        <div className="indent-style">
                          <FormGroup>
                            Royalties will be paid and accounted to the Producer
                            over a &nbsp;
                            <Select
                              className="select-mini"
                              value={this.props.period}
                              onChange={(e) =>
                                this.handleContent('period', e.target.value)
                              }
                            >
                              <option value="">select</option>
                              <option value="monthly">monthly</option>
                              <option value="quarterly">quarterly</option>
                              <option value="annual">annual</option>
                            </Select>{' '}
                            &nbsp;period within&nbsp;
                            <Select
                              className="select-mini"
                              value={this.props.periodDay}
                              onChange={(e) =>
                                this.handleContent('periodDay', e.target.value)
                              }
                            >
                              <option value="">select</option>
                              <option value="30">30</option>
                              <option value="60">60</option>
                              <option value="90">90</option>
                            </Select>
                            &nbsp;days of the end of that period.
                          </FormGroup>
                        </div>
                      </FormGroup>
                    </li>
                    <li>
                      <FormGroup>
                        The Producer &nbsp;
                        <Select
                          className="select-mini"
                          value={this.props.auditType}
                          onChange={(e) =>
                            this.handleContent('auditType', e.target.value)
                          }
                        >
                          <option value="">select</option>
                          <option value="will">will</option>
                          <option value="notWill">will not</option>
                        </Select>{' '}
                        &nbsp;have the right to conduct an audit
                      </FormGroup>
                    </li>
                  </ul>
                )}
              </FormGroup>

              {/* Optional question from ownership Tab */}
              {ownershipBlock &&
                ownershipBlock.options &&
                ownershipBlock.options.composition === 1 && (
                  <div>
                    <div>
                      <b>
                        What percentage of the minimum statutory royalty rate
                        will you pay the Producer for copies of the song
                        sold/downloaded in the U.S.?
                      </b>
                    </div>
                    <FormGroup style={{ marginLeft: '20px' }}>
                      Percentage of the minimum statutory rate: &nbsp;
                      <FormControl
                        type="number"
                        className="input-sm"
                        placeholder="%"
                        value={
                          this.props.statutoryPercentage
                            ? this.props.statutoryPercentage
                            : ''
                        }
                        onChange={(e) =>
                          this.handleContent(
                            'statutoryPercentage',
                            e.target.value
                          )
                        }
                      />
                      &nbsp;%
                    </FormGroup>
                  </div>
                )}
            </div>
          </Col>

          <Col sm={12}>{this.props.children}</Col>

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  Producers should be compensated for the work that they have
                  done. This section defines what that payment will be and when
                  it will be paid to the Producer for their work.
                </p>
              </div>
              <div className="expand" tabIndex="1">
                <p className="question">What are "net receipts"?</p>
                <p className="small">
                  Net receipts are the total funds generated by the master(s)
                  that the Owner receives, minus the Owner’s expenses relating
                  to recording the master(s) and the cost of manufacturing,
                  distributing, and union payments that were incurred relating
                  to records that the master appears on.
                </p>
              </div>
              <div className="expand" tabIndex="2">
                <p className="question">What is an "advance"?</p>
                <p className="small">
                  An “advance” is an upfront payment of money that is offset in
                  the future by royalties or other types of income.
                </p>
              </div>
              <div className="expand" tabIndex="3">
                <p className="question">What does "recoup" mean</p>
                <p className="small">
                  “Recoup” is short for “recuperation” and means to be
                  compensated for something that has been paid out, such as an
                  advance of money.
                </p>
              </div>
              <div className="expand" tabIndex="4">
                <p className="question">
                  What is the minimum statutory royalty rate?
                </p>
                <p className="small">
                  Sound Recordings are created from musical compositions. When a
                  Producer owns a share of the musical composition(s), they are
                  entitled to a statutory royalty called a “mechanical royalty.”
                  The amount of the royalty is fixed by the Copyright Royalty
                  Board and that fixed amount is owed to the Producer every time
                  a sound recording that contains their composition is
                  reproduced (streamed, sold, downloaded). You can propose to
                  pay the Producer the full (100%) amount of that royalty, or
                  you can propose to pay some lesser percentage of it.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/ContractBlock/Payments.jsx